import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import { listenForInstallPrompt } from '@/features/storefront/pwa/installPrompt';
import { isStorefrontPath } from '@/features/storefront/storefrontHost';

import './index.css';

// A shop page, which every shopper-facing URL is under. Chrome's offer to
// install arrives once, early, and long before the storefront has mounted -
// so it is caught here, before React, for the footer's install button.
//
// And the platform's own manifest in `index.html` is taken out first: left in,
// Chrome would offer to install NeonCarts on a merchant's shop until the
// shop's manifest replaced it (`useWebAppManifest`) - or, on the dashboard's
// preview of a shop, for good, since a preview never offers an install.
if (isStorefrontPath(window.location.pathname)) {
  document.querySelector('link[rel="manifest"]')?.remove();
  listenForInstallPrompt();
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root was not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
